import React, { useState } from "react";
import Login from "./login.component";
import SignUp from "./signup.component";
import "./AuthForm.css";

const AuthForm = ({
  isShowAuthForm,
  setIsShowAuthForm,
  isSignInProcess,
  setIsSignInProcess,
  isRegisterProcess,
  setIsRegisterProcess,
  setIsSignedIn,
}) => {
  const [response, setResponse] = useState("");
  const [registrationProcessing, setRegistrationProcessing] = useState(false);
  const [signUpProcessing, setSignUpProcessing] = useState(false);

  // swap between register and sign-in panels
  const handleSwapClick = () => {
    setIsSignInProcess((isSignInProcess) => !isSignInProcess);
    setIsRegisterProcess((isRegisterProcess) => !isRegisterProcess);
    setResponse("");
  };

  // close the authentication panel
  const handleExitClick = () => {
    setIsShowAuthForm(false);
    setIsSignInProcess(false);
    setIsRegisterProcess(false);
    document.getElementById("app-root").style.filter = "none";
  };

  return (
    <div>
      <div id="test" className="">
        <div className="login-form">
          <div className="form-box solid">
            <button
              type="button"
              className="close"
              aria-label="Close"
              onClick={handleExitClick}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h1 className="login-text">
              {isRegisterProcess ? "Register" : "Sign In"}
            </h1>
            {isRegisterProcess && (
              <>
                <SignUp
                  setIsShowAuthForm={setIsShowAuthForm}
                  setResponse={setResponse}
                  setRegistrationProcessing={setRegistrationProcessing}
                />
                <label>Already have an account?</label>
                <div className="swapButton__wrapper">
                  <button
                    className="btn btn-primary swapButton"
                    onClick={handleSwapClick}
                  >
                    Sign In
                  </button>
                </div>
              </>
            )}
            {isSignInProcess && (
              <>
                <Login
                  setIsShowAuthForm={setIsShowAuthForm}
                  setResponse={setResponse}
                  setSignUpProcessing={setSignUpProcessing}
                  setIsSignedIn={setIsSignedIn}
                />
                <label>Don't have account?</label>
                <div className="swapButton__wrapper">
                  <button
                    className="btn btn-primary swapButton"
                    onClick={handleSwapClick}
                  >
                    Register
                  </button>
                </div>
              </>
            )}
            <div className="responseMessage">{response ? response : null}</div>
            {(registrationProcessing || signUpProcessing) && (
              <div className="responseMessage">Processing...</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthForm;
